import { clamp, cx } from "./util";

const SEGMENTS = 14;

export interface MicLevelProps {
  /** 0–1, sampled per animation frame by `useMicLevel`. */
  level: number;
  /** Dim the whole readout when the mic is not armed. */
  armed: boolean;
  className?: string;
}

/**
 * A segmented LED ladder rather than a smooth bar — it reads at a glance from
 * arm's length and it is the only way a player knows the mic is actually
 * hearing them. Decorative: the armed/not-armed fact is announced separately.
 */
export function MicLevel({ level, armed, className }: MicLevelProps) {
  const lit = Math.round(clamp(level, 0, 1) * SEGMENTS);

  return (
    <div className={cx("bd-mic", !armed && "is-idle", className)}>
      <span className="t-label muted bd-mic-label">Mic</span>
      <div className="inset bd-mic-track" aria-hidden="true">
        {Array.from({ length: SEGMENTS }, (_, i) => (
          <span
            key={i}
            className={cx(
              "bd-mic-seg",
              i < lit && "is-lit",
              i >= SEGMENTS - 3 && "is-hot",
            )}
          />
        ))}
      </div>
      <span className="bd-sr-only" role="status">
        {armed ? "Microphone live" : "Microphone not armed"}
      </span>
    </div>
  );
}
